/**
 * Turns a post title into the URL segment the API will accept.
 *
 * The API validates slugs against /^[a-z0-9]+(?:-[a-z0-9]+)*$/, so anything
 * this produces has to match that or saving fails. Titles here are usually
 * Vietnamese, hence the diacritic stripping: "Bài viết" must become
 * "bai-viet", not "b-i-vi-t".
 */
export function slugify(value: string): string {
  return value
    .toLowerCase()
    // Separate base letters from their accents, then drop the accents.
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    // đ/Đ carries no combining mark, so NFD leaves it untouched.
    .replace(/đ/g, 'd')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 200)
    // A trailing hyphen can reappear after the length cut.
    .replace(/-+$/, '');
}
